import { useAppSelector } from '@shared/store';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountUser = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectUserData);
};
